function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 21"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.527 0a33.3 33.3 0 0133.527 33.074c0 11.4-7.063 25.21-17.714 28.31-7.22 2.369-10.325-10.4-13.957-9.414-2.555.7 7.7 13.267-1.856 14.178-.2 0-.407 0-.889-.011A33.229 33.229 0 010 33.074 33.3 33.3 0 0133.527 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.527 2c-4.26 0-8.392.823-12.28 2.445a31.453 31.453 0 00-10.023 6.666 30.952 30.952 0 00-6.751 9.877A30.495 30.495 0 002 33.074c0 4.143.813 8.169 2.417 11.964a31.066 31.066 0 006.59 9.815 31.328 31.328 0 009.756 6.692 30.984 30.984 0 0011.915 2.591c.386.008.584.01.75.011.763-.081 1.7-.294 2.035-.84.197-.321.365-1.007.052-2.456-.284-1.317-.866-2.793-1.38-4.095-.953-2.416-1.582-4.012-.88-5.412a2.503 2.503 0 011.603-1.305c.304-.082.617-.124.93-.124 2.358 0 3.925 2.14 5.74 4.619 1.765 2.41 3.766 5.143 6.054 5.143.36 0 .742-.065 1.134-.194l.032-.01.033-.01c4.453-1.296 8.603-4.896 11.686-10.137 2.915-4.956 4.587-10.88 4.587-16.252 0-4.193-.832-8.259-2.473-12.086a30.952 30.952 0 00-6.752-9.877 31.453 31.453 0 00-10.022-6.666A31.722 31.722 0 0033.527 2m0-2c18.516 0 33.527 14.808 33.527 33.074 0 11.396-7.063 25.21-17.714 28.31-.615.201-1.2.293-1.758.293-5.75 0-8.636-9.762-11.795-9.762-.134 0-.269.017-.404.054-2.555.696 7.7 13.267-1.856 14.178-.204 0-.407-.001-.889-.01C14.682 65.82 0 51.138 0 33.073 0 14.808 15.01 0 33.527 0z",
  fill: "#5dbeff"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 117",
  transform: "rotate(-13 210.865 -171.293)",
  stroke: "#5dbeff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.719,
  cy: 5.856,
  rx: 4.719,
  ry: 5.856,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.719,
  cy: 5.856,
  rx: 3.719,
  ry: 4.856
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.998 17.99c1.561 1.796.077 3.849-1.718 5.408L33.328 38.18a4.304 4.304 0 01-5.646-6.498l16.871-13.26c1.794-1.559 3.888-2.224 5.445-.433z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.49 19.304c-.354-.407-.598-.41-.838-.375-.483.07-1.135.436-1.787 1.003l-.038.033-.038.03L28.962 33.22c-.445.4-.713.95-.755 1.55a2.289 2.289 0 00.559 1.672 2.307 2.307 0 003.209.263l14.9-14.73.045-.045.048-.042c1.08-.938 1.461-1.59 1.592-1.894.168-.39.096-.5-.07-.69M50 17.992c1.56 1.795.075 3.847-1.72 5.406L33.328 38.18a4.304 4.304 0 01-5.646-6.498l16.87-13.26c1.795-1.559 3.889-2.224 5.448-.43z",
  fill: "#5dbeff"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 19",
  d: "M18.96 45.23s3.773-11.57 7.427-7.009-7.428 7.009-7.428 7.009z",
  stroke: "#5dbeff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 118",
  transform: "rotate(37 -7.381 29.674)",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.5,
  cy: 6.5,
  rx: 4.5,
  ry: 6.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.5,
  cy: 6.5,
  rx: 4,
  ry: 6
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 119",
  transform: "rotate(60 13.425 29.64)",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 5.5,
  rx: 4,
  ry: 5.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 5.5,
  rx: 3.5,
  ry: 5
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 120",
  transform: "rotate(-173.98 8.005 19.502)",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 5.5,
  rx: 4,
  ry: 5.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 5.5,
  rx: 3.5,
  ry: 5
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 15",
  stroke: "#5dbeff",
  d: "M29.812 30.427l4.685 5.572"
}));

var SvgDesign = function SvgDesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67.054 66.147",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/design.06eb208c.svg";
export { ForwardRef as ReactComponent };